<template>
  <component :is="canManage ? 'button' : 'article'"
    :type="canManage ? 'button' : undefined"
    :aria-label="canManage ? `Reponer comprobante ${alert.series}` : undefined"
    class="voucher-replenishment-alert"
    :class="{ 'voucher-replenishment-alert-compact': compact }"
    @click="canManage && $emit('replenish', alert)">
    <div class="voucher-replenishment-alert-summary">
      <p class="voucher-replenishment-alert-title">
        {{ alert.series }}<span v-if="!compact"> · {{ alert.description }}</span>
      </p>
      <VoucherReplenishmentStatus :exhausted="alert.exhausted" :remaining="alert.remaining" />
    </div>
    <template v-if="!compact">
      <p class="voucher-replenishment-alert-range">Actual: {{ alert.current }} · Final: {{ alert.final }}</p>
      <p class="voucher-replenishment-alert-guidance">
        {{ alert.electronic ? 'Solicita una nueva autorización de NCF y actualiza el número final autorizado.' : 'Solicita la reposición de esta secuencia y actualiza su número final.' }}
      </p>
      <p class="voucher-replenishment-alert-range">El aviso permanece hasta ampliar el rango y tener más de {{ alert.threshold }} números disponibles.</p>
    </template>
    <p class="voucher-replenishment-alert-action">
      {{ canManage ? 'Abrir este comprobante para reponer' : 'Comunícalo al administrador para reponer la secuencia.' }}
    </p>
  </component>
</template>

<script>
import VoucherReplenishmentStatus from "./VoucherReplenishmentStatus.vue";

export default {
  name: "VoucherReplenishmentAlert",
  components: { VoucherReplenishmentStatus },
  props: {
    alert: { type: Object, required: true },
    canManage: Boolean,
    compact: Boolean,
  },
  emits: ["replenish"],
};
</script>

<style scoped>
.voucher-replenishment-alert {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 12px 16px;
  border-bottom: 1px solid #fee2e2;
  text-align: left;
  color: #334155;
}
button.voucher-replenishment-alert:hover,
button.voucher-replenishment-alert:focus-visible {
  background: #fee2e2;
}
button.voucher-replenishment-alert:focus-visible {
  outline: 2px solid #991b1b;
  outline-offset: -2px;
}
.voucher-replenishment-alert-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px 12px;
}
.voucher-replenishment-alert-title {
  font-size: 14px;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.voucher-replenishment-alert-range,
.voucher-replenishment-alert-guidance,
.voucher-replenishment-alert-action {
  margin-top: 4px;
  font-size: 12px;
}
.voucher-replenishment-alert-range { color: #475569; }
.voucher-replenishment-alert-guidance { margin-top: 8px; }
.voucher-replenishment-alert-action { color: #991b1b; font-weight: 600; }
button .voucher-replenishment-alert-action { text-decoration: underline; }
.voucher-replenishment-alert-compact {
  padding: 6px 8px;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  background: #fff;
}
</style>
